module.exports = __webpack_public_path__ + "static/media/onboarding-what-to-expect-line-horizontal.b4cca0da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-what-to-expect-line-horizontal.svg
// module id = 693
// module chunks = 0